import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/indexs'
import classselection from '@/components/classselection'
import campuspaymen from '@/components/campuspaymen'
import classcard from '@/components/classcard'
import homeschool from '@/components/homeschool'
import smarteducational from '@/components/smarteducational'
import companyprofile from '@/components/companyprofile'
import businesscooperation from '@/components/businesscooperation'
import applyfortrial from '@/components/applyfortrial'
import header from '@/components/header'
import footer from '@/components/footer'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/header',
      name: 'header',
      component: header
    },
    {
      path: '/footer',
      name: 'footer',
      component: footer
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/classselection',
      name: 'classselection',
      component: classselection
    },

    {
      path: '/classcard',
      name: 'classcard',
      component: classcard
    },
    {
      path: '/homeschool',
      name: 'homeschool',
      component: homeschool
    },
    {
      path: '/smarteducational',
      name: 'smarteducational',
      component: smarteducational
    },
    {
      path: '/companyprofile',
      name: 'companyprofile',
      component: companyprofile
    },
    {
      path: '/businesscooperation',
      name: 'businesscooperation',
      component: businesscooperation
    },
    {
      path: '/campuspaymen',
      name: 'campuspaymen',
      component: campuspaymen
    },
    {
      path: '/applyfortrial',
      name: 'applyfortrial',
      component: applyfortrial
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js